import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home';
import ContactUs from './pages/ContactUs';
import IceCream from './pages/IceCream';
import Novelties from './pages/Novelties';
import './styles/global.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';

// Scroll to top component - must be inside Router
const ScrollToTop = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// Scroll to hash anchor on route change
const ScrollToHash = () => {
  const { hash, pathname } = useLocation();
  
  React.useEffect(() => {
    if (hash) {
      // Add a small delay to ensure the DOM is ready, especially when navigating from other pages
      const timer = setTimeout(() => {
        const el = document.getElementById(hash.replace('#', ''));
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
      
      return () => clearTimeout(timer);
    }
  }, [hash, pathname]); // Also trigger on pathname change to handle navigation from other pages
  
  return null;
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <ScrollToHash />
      <div className="App">
        {/* <Header /> */}
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<Home />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/ice-cream" element={<IceCream />} />
            <Route path="/novelties" element={<Novelties />} />
            <Route path="/order/euless" element={<Home />} />
            <Route path="/order/frisco" element={<Home />} />
            <Route path="/order/irving" element={<Home />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
